import { CASE_MANAGE_PATH, CHOOSE_CASE_PROPERTY_PATH } from '@constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import { isStoreAccount, isStoreHidden } from '../..'

export const goToPubCase = () => {
  let msg = isStoreHidden()
  if (msg != 'success') {
    message.error(msg)
    return false
  }
  if (isStoreAccount()) {
    hashHistory.push(CHOOSE_CASE_PROPERTY_PATH)
  } else {
    hashHistory.push(`${CASE_MANAGE_PATH}/add`)
  }
}

/**
 * 根据不同类目区分案例显示的名字
 */
export const getCaseName = () => {
  return isSiDaProperty() ? '作品' : '案例'
}

export const getCaseManageTitle = () => {
  const name = getCaseName()
  return `${name}管理`
}
